// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-form {
  --input-height: 50px;
  margin-top: 22px;
}

.payment-form .header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
}

.payment-form .header svg {
  margin-left: auto;
  margin-right: 5px;
  height: 12px;
  width: 8px;
}

.payment-form .header .highlight {
  color: var(--main-highlight-color);
}

.payment-form .input-container {
  min-height: 78px;
}

.payment-form .exp-cvv-container {
  display: flex;
  justify-content: space-between;
  min-height: 74px;
  gap: 20px;
}

.payment-form .exp-cvv-container .exp-cvv-input-container {
  flex: 1;
}

.payment-form .engine-container {
  margin-bottom: 7px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.payment-form.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".payment-form {\n  --input-height: 50px;\n  margin-top: 22px;\n}\n\n.payment-form .header {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.02em;\n}\n\n.payment-form .header svg {\n  margin-left: auto;\n  margin-right: 5px;\n  height: 12px;\n  width: 8px;\n}\n\n.payment-form .header .highlight {\n  color: var(--main-highlight-color);\n}\n\n.payment-form .input-container {\n  min-height: 78px;\n}\n\n.payment-form .exp-cvv-container {\n  display: flex;\n  justify-content: space-between;\n  min-height: 74px;\n  gap: 20px;\n}\n\n.payment-form .exp-cvv-container .exp-cvv-input-container {\n  flex: 1;\n}\n\n.payment-form .engine-container {\n  margin-bottom: 7px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
